import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { InternalAvatar } from '../../internal';
import * as styles from './styles.module.css';
/**
 * Компонент аватарки
 *
 * Плейсхолдеры и скругления зависят от типа пользователя:
 * Люди - круглые
 * Компании - квадратные
 */

export var DoubleAvatar = /*#__PURE__*/React.forwardRef(function DoubleAvatar(_ref, ref) {
  var primary = _ref.primary,
      secondary = _ref.secondary,
      size = _ref.size,
      highlight = _ref.highlight;
  return /*#__PURE__*/React.createElement("div", {
    ref: ref,
    className: styles['avatars'],
    style: {
      width: size,
      height: size
    }
  }, /*#__PURE__*/React.createElement(InternalAvatar, _extends({}, primary, {
    className: styles['primary'],
    ref: ref,
    highlightWidth: 4,
    highlight: highlight,
    size: calcPrimarySize(size)
  })), /*#__PURE__*/React.createElement(InternalAvatar, _extends({}, secondary, {
    className: styles['secondary'],
    highlightWidth: 2,
    highlight: highlight,
    size: calcSecondarySize(size)
  })));
});
var PRIMARY_SIZE_RATIO = 88 / 94;
var SECONDARY_SIZE_RATIO = 32 / 94;

function calcPrimarySize(size) {
  return Math.round(size * PRIMARY_SIZE_RATIO / 4) * 4;
}

function calcSecondarySize(size) {
  return Math.round(size * SECONDARY_SIZE_RATIO / 4) * 4;
}